import { render, staticRenderFns } from "./system-settings.vue?vue&type=template&id=413ef516"
import script from "./system-settings.vue?vue&type=script&lang=js"
export * from "./system-settings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports